





































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DynamicDivider from '@/components/DynamicDivider.vue';
import { constants } from 'http2';
import { from } from 'rxjs';


@Component({
  components: {
    DynamicDivider,
  },
})
export default class Footer extends Vue {
    public icons: object = [
        {
            value: 'fab fa-facebook-f',
            href: 'https://www.facebook.com/luxtagnem/',
        },
        {
            value: 'fab fa-youtube',
            href: 'https://www.youtube.com/channel/UC8gRXlelLzkfQ_uyqI2sFLg',
        },
        {
            value: 'fab fa-linkedin-in',
            href: ' https://www.linkedin.com/company/luxtag',
        },
        {
            value: 'fab fa-instagram',
            href: 'https://www.instagram.com/luxtag.io/',
        },

    ];

    public cFooterStyle = {
        paddingBottom: '0px',
    };

    public cLuxtagPatentStyle = {
        fontSize: '13px',
    };

    public mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    }

    private onResize() {
        // dynamic footer bottom padding
        let footerBottomPadding = '0px';
        if (window.innerWidth <= this.$vuelux.breakpoint.tablet) {
            footerBottomPadding = '88px';
        }
        this.cFooterStyle.paddingBottom = footerBottomPadding;

        // dynamic patent font size
        let patentStyleFontSize = '14px';
        if (window.innerWidth <= this.$vuelux.breakpoint.mobileS) {
            patentStyleFontSize = '11px';
        } else if (window.innerWidth <= this.$vuelux.breakpoint.tabletL) {
            patentStyleFontSize = '12px';
        }
        this.cLuxtagPatentStyle.fontSize = patentStyleFontSize;
    }
}
